/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface RestError {
  /** Error code */
  code?: number
  /** Error name */
  status?: string
  /** Error message */
  message?: string
  /** Errors */
  errors?: Record<string, any>
}

export interface RestPaginationMetadata {
  total?: number
  total_pages?: number
  first_page?: number
  last_page?: number
  page?: number
  previous_page?: number
  next_page?: number
}

export interface RestApiRequestPaginationPayload {
  /** @default 20 */
  per_page?: number
  /** @default 1 */
  page?: number
}

export interface RestApiActionPlanRequestFilterPayload {
  /** @default false */
  hidden?: boolean
  /** @default false */
  anomalies?: boolean
}

export interface RestApiActionPlanRequestPayload {
  /** @default null */
  search?: string | null
  /** @default {"per_page":20,"page":1} */
  pagination?: RestApiRequestPaginationPayload
  /** @default {"hidden":false,"anomalies":false} */
  filter?: RestApiActionPlanRequestFilterPayload
  /** @default false */
  with_all_actions_summary?: boolean
}

export interface RestAPIPagingData {
  page_count: number
  count: number
}

export interface RestAPII18NString {
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
}

export interface RestAPIRegisterAttachment {
  id: number
  identifier: string
  name: RestAPII18NString
  type: RestApiRegisterAttachmentType
}

export interface RestAPIActionPlanRights {
  edit: boolean
  delete: boolean
}

export interface RestApiActionPlan {
  id: number
  name: RestAPII18NString
  completion: number
  nb_groups: number
  nb_actions: number
  workload: number
  cost: number
  nb_anomalies: number
  attachment: RestAPIRegisterAttachment
  is_hidden: boolean
  visible_by_everyone: boolean
  rights: RestAPIActionPlanRights
}

export interface RestApiActionPlanSummary {
  id: string
  name: RestAPII18NString
  completion: number
  nb_actions: number
  workload: number
  cost: number
  nb_anomalies: number
}

export interface RestApiListActionPlanResponse {
  paging: RestAPIPagingData
  data: RestApiActionPlan[]
  /** @default null */
  all_actions_summary?: RestApiActionPlanSummary | null | (RestApiActionPlanSummary & null)
}

export interface RestI18NString {
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
}

export interface RestActionPlan {
  id: number
  name: RestI18NString
}

export interface RestAPII18NStringInput {
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
}

export interface RestAPIOwner {
  type: RestApiOwnerType
  id: number
}

export interface RestAPISubAction {
  name: RestAPII18NStringInput
  proof_required: boolean
  /** @default null */
  description?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
  /** @default null */
  identifier?: string | null
  /** @default null */
  subaction_position?: number | null
  /** @default null */
  cost?: number | null
  /** @default null */
  workload?: number | null
  /** @default null */
  progress?: number | null
  /** @default null */
  done?: boolean | null
  /** @default null */
  assigned_to?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  id?: number | null
  /** @default null */
  link?: string | null
  /** @default null */
  spent_cost?: number | null
  /** @default null */
  spent_workload?: number | null
}

export interface RestActionGroup {
  id: number
  identifier: string
  name: string
}

export interface RestActionMeasure {
  security_measure_id: number
  perimeter_id: number
  impact: number
}

export interface RestLabel {
  id: number
  name: string
}

export interface RestActionAssociations {
  group_action?: RestActionGroup[]
  measures?: RestActionMeasure[]
  labels?: RestLabel[]
  isp_projects?: number[]
  incidents?: number[]
  gaps?: number[]
  exemptions?: number[]
}

export interface RestAPIActionCriteria {
  perimeter_id: number
  /** @default null */
  identifier?: string | null
  /** @default null */
  name?: RestI18NString | null | (RestI18NString & null)
  /** @default null */
  description?: RestI18NString | null | (RestI18NString & null)
  status: RestApiActionCriteriaStatus
  action_plans: RestActionPlan[]
  sub_action_items: RestAPISubAction[]
  /** @default null */
  assigned_to?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  completion?: number | null
  /** @default null */
  category_id?: number | null
  /**
   * @format date
   * @default null
   */
  target_date?: string | null
  /**
   * @format date
   * @default null
   */
  date_start?: string | null
  /** @default null */
  init_workload?: number | null
  /** @default null */
  initial_cost?: number | null
  /** @default null */
  file_required?: boolean | null
  /** @default null */
  priority?: number | null
  /** @default null */
  is_template?: boolean | null
  /** @default null */
  forked_from_id?: number | null
  /** @default null */
  associated_objects?: RestActionAssociations | null | (RestActionAssociations & null)
  /** @default null */
  template_type?: RestApiActionCriteriaTemplateType
}

export interface RestAPIActionPlanId {
  id: number
}

export interface RestAPIActionCreated {
  id: number
  identifier: string
  name: RestAPII18NString
  completion: number
  perimeter_id: number
  status: RestApiActionCreatedStatus
  /** @default null */
  action_plan?: RestAPIActionPlanId | null | (RestAPIActionPlanId & null)
  /** @default null */
  impact?: number | null
  /** @default null */
  security_measure_id?: number | null
}

export interface RestAPIAddedActionResponse {
  data: RestAPIActionCreated
}

export interface RestAPIConsumePerimeter {
  id: number
}

export interface RestAPIActionPlanWithName {
  id: number
  /** @default null */
  name?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
}

export interface RestAPIActionRegisterGroup {
  id: number
  action_register_id: number
  /** @default null */
  name?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
}

export interface RestAPIActionGroup {
  id: number
  identifier: string
  name: string
}

export interface RestAPILabel {
  id: number
  name: string
}

export interface RestAPIActionUpdateAssociationsRequest {
  /** @default null */
  group_action?: RestAPIActionGroup[] | null
  /** @default null */
  labels?: RestAPILabel[] | null
  /** @default null */
  isp_projects?: number[] | null
  /** @default null */
  incidents?: number[] | null
  /** @default null */
  gaps?: number[] | null
  /** @default null */
  exemptions?: number[] | null
}

export interface RestAPIIspImpact {
  id: number
  /**
   * @format date
   * @default null
   */
  target_date?: string | null
}

export interface RestAPIActionUpdateRequest {
  action_id: number
  /** @default null */
  status?: RestApiActionUpdateRequestStatus
  /** @default null */
  identifier?: string | null
  /** @default null */
  name?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
  /** @default null */
  perimeter_id?: number | null
  /** @default null */
  description?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
  /** @default null */
  priority?: number | null
  /** @default null */
  category_id?: number | null
  /**
   * @format date
   * @default null
   */
  target_date?: string | null
  /**
   * @format date
   * @default null
   */
  date_start?: string | null
  /** @default null */
  file_required?: boolean | null
  /** @default null */
  assigned_to?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  initial_cost?: number | null
  /** @default null */
  init_workload?: number | null
  /** @default null */
  spent_cost?: number | null
  /** @default null */
  spent_workload?: number | null
  /** @default null */
  completion?: number | null
  /** @default null */
  need_mapping?: boolean | null
  /** @default null */
  link?: string | null
  /** @default null */
  current_efficiency?: number | null
  /** @default null */
  consume_perimeters?: RestAPIConsumePerimeter[] | null
  /** @default null */
  action_plans?: RestAPIActionPlanWithName[] | null
  /** @default null */
  action_register_groups?: RestAPIActionRegisterGroup[] | null
  /** @default null */
  sub_action_items?: RestAPISubAction[] | null
  /** @default null */
  associated_objects?: RestAPIActionUpdateAssociationsRequest | null | (RestAPIActionUpdateAssociationsRequest & null)
  /** @default null */
  isp_impacts?: RestAPIIspImpact[] | null
}

export interface RestAPIPerimeter {
  id: number
  identifier: string
  name: RestAPII18NString
}

export interface RestApiActionUpdated {
  id: number
  identifier: string
  action_type: RestApiActionUpdatedActionType
  completion: number
  /** @format date */
  date_start: string
  description: RestAPII18NString
  name: RestAPII18NString
  perimeter: RestAPIPerimeter
  priority: number
  status: RestApiActionUpdatedStatus
  /** @format date */
  target_date: string
}

export interface RestApiActionRequestSearchPayload {
  /** @default null */
  criteria?: string | null
}

export interface RestApiActionRequestPaginationPayload {
  /** @default 1 */
  page?: number
  /** @default 20 */
  per_page?: number
}

export interface RestApiActionManager {
  id: number
  type: RestApiActionManagerType
}

export interface RestApiActionRequestFilterPayload {
  /** @default null */
  perimeters?: number[] | null
  /** @default null */
  groups?: number[] | null
  /** @default null */
  labels?: number[] | null
  /** @default null */
  managers?: RestApiActionManager[] | null
  /** @default null */
  priorities?: number[] | null
  /** @default null */
  statuses?: RestApiActionRequestFilterPayloadStatuses[] | null
  /** @default null */
  sources?: RestApiActionRequestFilterPayloadSources[] | null
  /** @default null */
  types?: RestApiActionRequestFilterPayloadTypes[] | null
  /** @default null */
  is_anomaly?: boolean | null
  /** @default null */
  action_plan_id?: number | null
  /** @default null */
  categories?: number[] | null
  /**
   * @format date-time
   * @default null
   */
  updated_at_from?: string | null
  /**
   * @format date-time
   * @default null
   */
  updated_at_to?: string | null
}

export interface RestApiActionRequestSortPayload {
  /** @default "IDENTIFIER" */
  field?: RestApiActionRequestSortPayloadField
  /** @default "ASC" */
  order?: RestApiActionRequestSortPayloadOrder
}

export interface RestApiActionRequestPayload {
  /** @default {"criteria":null} */
  search?: RestApiActionRequestSearchPayload
  /** @default {"page":1,"per_page":20} */
  pagination?: RestApiActionRequestPaginationPayload
  /** @default {"perimeters":null,"groups":null,"labels":null,"managers":null,"priorities":null,"statuses":null,"sources":null,"types":null,"is_anomaly":null,"action_plan_id":null,"categories":null,"updated_at_from":null,"updated_at_to":null} */
  filter?: RestApiActionRequestFilterPayload
  /** @default {"field":"IDENTIFIER","order":"ASC"} */
  sort?: RestApiActionRequestSortPayload
}

export interface RestAPIActionManager {
  label: string
  type: RestApiActionManagerType
}

export interface RestAPIActionPerimeter {
  id: number
  name: RestAPII18NString
  type: RestApiActionPerimeterType
}

export interface RestApiAction {
  id: number
  project_name: RestAPII18NString
  identifier: string
  /** @default null */
  manager?: RestAPIActionManager | null | (RestAPIActionManager & null)
  name: RestAPII18NString
  priority: number
  perimeter: RestAPIActionPerimeter
  status: RestApiActionStatus
  /**
   * @format date
   * @default null
   */
  target_date?: string | null
  anomalies: RestApiActionAnomalies[]
  action_type: RestApiActionActionType
  /**
   * @format date-time
   * @default null
   */
  updated_at?: string | null
}

export interface RestApiListActionResponse {
  paging: RestAPIPagingData
  data: RestApiAction[]
}

export interface RestApiActionPerimeterFilterValue {
  value: number
  label: RestAPII18NString
}

export interface RestApiActionPerimeterFilterData {
  type: RestApiActionPerimeterFilterDataType
  values: RestApiActionPerimeterFilterValue[]
}

export interface RestApiActionGroupFilterValue {
  value: number
  label: RestAPII18NString
}

export interface RestApiActionGroupFilterData {
  type: RestApiActionGroupFilterDataType
  values: RestApiActionGroupFilterValue[]
}

export interface RestApiActionLabelFilterValue {
  value: number
  label: RestAPII18NString
}

export interface RestApiActionLabelFilterData {
  type: RestApiActionLabelFilterDataType
  values: RestApiActionLabelFilterValue[]
}

export interface RestAPIFilterItemExtraData {
  /** @default null */
  color?: string | null
  /** @default null */
  icon?: string | null
}

export interface RestApiActionPriorityFilterValue {
  value: number
  label: RestAPII18NString
  extra: RestAPIFilterItemExtraData
}

export interface RestApiActionPriorityFilterData {
  type: RestApiActionPriorityFilterDataType
  values: RestApiActionPriorityFilterValue[]
}

export interface RestApiActionStatusFilterValue {
  value: RestApiActionStatusFilterValueValue
}

export interface RestApiActionStatusFilterData {
  type: RestApiActionStatusFilterDataType
  values: RestApiActionStatusFilterValue[]
}

export interface RestApiActionManagerFilterValue {
  value: number
  label: string
  type: RestApiActionManagerFilterValueType
}

export interface RestApiActionManagerFilterData {
  type: RestApiActionManagerFilterDataType
  values: RestApiActionManagerFilterValue[]
}

export interface RestApiActionIsAnomalyFilterValue {
  value: boolean
}

export interface RestApiActionIsAnomalyFilterData {
  type: RestApiActionIsAnomalyFilterDataType
  values: RestApiActionIsAnomalyFilterValue[]
}

export interface RestApiActionActionTypeFilterValue {
  value: RestApiActionActionTypeFilterValueValue
}

export interface RestAPIActionActionTypeFilterData {
  type: RestApiActionActionTypeFilterDataType
  values: RestApiActionActionTypeFilterValue[]
}

export interface RestApiActionSourceFilterValue {
  value: RestApiActionSourceFilterValueValue
}

export interface RestAPIActionSourceFilterData {
  type: RestApiActionSourceFilterDataType
  values: RestApiActionSourceFilterValue[]
}

export interface RestApiActionDataFilter {
  perimeter: RestApiActionPerimeterFilterData
  group: RestApiActionGroupFilterData
  label: RestApiActionLabelFilterData
  priority: RestApiActionPriorityFilterData
  status: RestApiActionStatusFilterData
  manager: RestApiActionManagerFilterData
  is_anomaly: RestApiActionIsAnomalyFilterData
  action_type: RestAPIActionActionTypeFilterData
  source: RestAPIActionSourceFilterData
}

export interface RestApiFiltersActionResponse {
  data: RestApiActionDataFilter
}

export interface RestApiActionStatusCountResponse {
  count: number
}

export interface RestApiActionImpactPerimeter {
  id: number
  /** @default null */
  identifier?: string | null
  name: RestAPII18NString
}

export interface RestApiActionImpact {
  type: string
  id: number
  name: RestAPII18NString
  /** @default null */
  identifier?: string | null
  /** @default null */
  perimeter?: RestApiActionImpactPerimeter | null | (RestApiActionImpactPerimeter & null)
  /** @default null */
  current_efficiency?: number | null
}

export interface RestApiActionFinishImpactsResponse {
  has_impact: boolean
  impacts?: RestApiActionImpact[]
}

export interface RestApiActorRequestPaginationPayload {
  /** @default 1 */
  page?: number
  /** @default 20 */
  per_page?: number
}

export interface RestApiActorRequestFilterPayload {
  /** @default null */
  search?: string | null
  /** @default null */
  is_assigned_in_action_register_id?: number | null
  /** @default null */
  is_assigned_in_campaigns?: boolean | null
  /** @default null */
  type?: RestApiActorRequestFilterPayloadType
  /** @default null */
  is_authorized_on_perimeter_ids?: number[] | null
}

export interface RestApiActorRequestPayload {
  /** @default {"page":1,"per_page":20} */
  pagination?: RestApiActorRequestPaginationPayload
  /** @default {"search":null,"is_assigned_in_action_register_id":null,"is_assigned_in_campaigns":null,"type":null,"is_authorized_on_perimeter_ids":null} */
  filters?: RestApiActorRequestFilterPayload
}

export interface RestApiActor {
  id: number
  label: string
  type: string
  /** @default null */
  email?: string | null
}

export interface RestApiListActorResponse {
  paging: RestAPIPagingData
  data: RestApiActor[]
}

export interface RestApiAttachment {
  id: number
  parent_ids: number[]
  identifier: string
  name: RestAPII18NString
}

export interface RestAPIAttachmentListResponse {
  data: RestApiAttachment[]
}

export interface RestApiUser {
  id: number
  first_name: string
  last_name: string
  email: string
}

export interface RestApiGroup {
  id: number
  name: string
  /** @default null */
  email?: string | null
}

export interface RestApiUserGroups {
  users: RestApiUser[]
  groups: RestApiGroup[]
}

export interface RestAPIUserListResponse {
  data: RestApiUserGroups
}

export interface RestAPIPredicateFilter {
  operator?: RestApiPredicateFilterOperator
  value: any[]
}

export interface RestAPICampaignGroupedFilter {
  /** @default null */
  search?: RestAPIPredicateFilter[] | null
  /** @default null */
  perimeter_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  questionnaire_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  policy_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  managers?: RestAPIPredicateFilter[] | null
  /** @default null */
  statuses?: RestAPIPredicateFilter[] | null
}

export interface RestAPICampaignGroupBy {
  group: RestApiCampaignGroupByGroup
  limit_per_group: number
}

export interface RestAPICampaignGroupedRequest {
  campaign_filter?: RestAPICampaignGroupedFilter
  /** @default null */
  sort_field?: RestApiCampaignGroupedRequestSortField
  /** @default null */
  sort_order?: RestApiCampaignGroupedRequestSortOrder
  /** @default null */
  group_by?: RestAPICampaignGroupBy | null | (RestAPICampaignGroupBy & null)
  /** @default null */
  pagination?: RestApiRequestPaginationPayload | null | (RestApiRequestPaginationPayload & null)
}

export interface RestAPICampaignGroupStatusValue {
  value: RestApiCampaignGroupStatusValueValue
  label: RestAPII18NString
  /** @default "STATUS" */
  type?: RestApiCampaignGroupStatusValueType
}

export interface RestAPICampaignGroupPerimeterValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "PERIMETER" */
  type?: RestApiCampaignGroupPerimeterValueType
}

export interface RestAPICampaignGroupPolicyValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "POLICY" */
  type?: RestApiCampaignGroupPolicyValueType
}

export interface RestAPICampaignGroupQuestionnaireValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "QUESTIONNAIRE" */
  type?: RestApiCampaignGroupQuestionnaireValueType
}

export interface RestAPICampaignAssigneeKey {
  id: number
  type: RestApiCampaignAssigneeKeyType
}

export interface RestAPICampaignGroupManagerValue {
  /** @default null */
  value?: RestAPICampaignAssigneeKey | null | (RestAPICampaignAssigneeKey & null)
  label: RestAPII18NString
  /** @default "MANAGER" */
  type?: RestApiCampaignGroupManagerValueType
}

export type RestAPICampaignGroup =
  | RestAPICampaignGroupStatusValue
  | RestAPICampaignGroupPerimeterValue
  | RestAPICampaignGroupPolicyValue
  | RestAPICampaignGroupQuestionnaireValue
  | RestAPICampaignGroupManagerValue

export interface RestAPICampaignAssignee {
  id: number
  type: RestApiCampaignAssigneeType
  label: string
  /** @default null */
  email?: string | null
}

export interface RestAPICampaignPerimeter {
  id: number
  /** @default null */
  identifier?: string | null
  name: RestAPII18NString
  /** @default null */
  type?: RestApiCampaignPerimeterType | null
}

export interface RestAPICampaignReference {
  id: number
  /** @default null */
  identifier?: string | null
  name: RestAPII18NString
}

export interface RestAPIListedCampaign {
  id: number
  name: RestAPII18NString
  status: RestApiListedCampaignStatus
  managers: RestAPICampaignAssignee[]
  progression: number
  /** @default null */
  perimeter?: RestAPICampaignPerimeter | null | (RestAPICampaignPerimeter & null)
  /**
   * @format date
   * @default null
   */
  end_date?: string | null
  /** @default null */
  policy?: RestAPICampaignReference | null | (RestAPICampaignReference & null)
  /** @default null */
  questionnaire?: RestAPICampaignReference | null | (RestAPICampaignReference & null)
  /** @default null */
  score?: number | null
}

export interface RestAPICampaignGroupData {
  group?: RestAPICampaignGroup
  items: RestAPIListedCampaign[]
  total: number
}

export interface RestAPICampaignPagingGroupData {
  page_count: number
  count: number
  groups_count: number
}

export interface RestAPIPaginatedGroupCampaignsResponse {
  groups: RestAPICampaignGroupData[]
  paging: RestAPICampaignPagingGroupData
}

export interface RestAPICatalogPolicy {
  id: number
  identifier: string
  name: RestAPII18NString
  public: boolean
  measure_count: number
}

export interface RestAPICatalogPoliciesListResponse {
  data: RestAPICatalogPolicy[]
}

export interface RestApiCategoryRequestPaginationPayload {
  /** @default 1 */
  page?: number
  /** @default 20 */
  per_page?: number
}

export interface RestApiCategoryRequestFilterPayload {
  /** @default null */
  search?: string | null
  /** @default null */
  is_used_in_action_register_id?: number | null
}

export interface RestApiCategoryRequestPayload {
  /** @default {"page":1,"per_page":20} */
  pagination?: RestApiCategoryRequestPaginationPayload
  /** @default {"search":null,"is_used_in_action_register_id":null} */
  filters?: RestApiCategoryRequestFilterPayload
}

export interface RestApiCategory {
  id: number
  label: RestAPII18NString
  identifier: string
}

export interface RestApiListCategoryResponse {
  paging: RestAPIPagingData
  data: RestApiCategory[]
}

export interface RestAPIDashboardUser {
  id: number
  name: string
}

export interface RestAPIDashboardUsersResponse {
  users: RestAPIDashboardUser[]
}

export interface RestAPIAssociateUsersRequest {
  user_ids: number[]
}

export interface RestApiEvaluationCommentUser {
  id: number
  name: string
  email: string
  initials: string
}

export interface RestApiEvaluationComment {
  id: number
  comment: string
  /** @default null */
  user?: RestApiEvaluationCommentUser | null | (RestApiEvaluationCommentUser & null)
  from_me: boolean
  /**
   * UTC datetime formatted as DD/MM/YYYY HH:mm:ss
   * @pattern ^\d{2}/\d{2}/\d{4} \d{2}:\d{2}:\d{2}$
   * @example "06/12/2021 09:05:37"
   */
  timestamp: string
}

export interface RestApiEvaluationCommentListResponse {
  data: RestApiEvaluationComment[]
}

export interface RestApiEvaluationCommentRequest {
  comment: string
}

export interface RestAPIEvaluationGroupedFilter {
  /** @default null */
  search?: RestAPIPredicateFilter[] | null
  /** @default null */
  campaign_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  perimeter_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  questionnaire_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  policy_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  statuses?: RestAPIPredicateFilter[] | null
  /** @default null */
  contributors?: RestAPIPredicateFilter[] | null
  /** @default null */
  managers?: RestAPIPredicateFilter[] | null
}

export interface RestAPIEvaluationGroupBy {
  group: RestApiEvaluationGroupByGroup
  limit_per_group: number
}

export interface RestAPIEvaluationGroupedRequest {
  evaluation_filter?: RestAPIEvaluationGroupedFilter
  /** @default null */
  sort_field?: RestApiEvaluationGroupedRequestSortField
  /** @default null */
  sort_order?: RestApiEvaluationGroupedRequestSortOrder
  /** @default null */
  group_by?: RestAPIEvaluationGroupBy | null | (RestAPIEvaluationGroupBy & null)
  /** @default null */
  pagination?: RestApiRequestPaginationPayload | null | (RestApiRequestPaginationPayload & null)
}

export interface RestAPIEvaluationGroupCampaignValue {
  value: number
  label: RestAPII18NString
  /** @default "CAMPAIGN" */
  type?: RestApiEvaluationGroupCampaignValueType
}

export interface RestAPIEvaluationGroupPerimeterValue {
  value: number
  label: RestAPII18NString
  /** @default "PERIMETER" */
  type?: RestApiEvaluationGroupPerimeterValueType
}

export interface RestAPIEvaluationGroupPolicyValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "POLICY" */
  type?: RestApiEvaluationGroupPolicyValueType
}

export interface RestAPIEvaluationGroupQuestionnaireValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "QUESTIONNAIRE" */
  type?: RestApiEvaluationGroupQuestionnaireValueType
}

export interface RestAPIEvaluationGroupContributorValue {
  /** @default null */
  value?: RestAPICampaignAssigneeKey | null | (RestAPICampaignAssigneeKey & null)
  label: RestAPII18NString
  /** @default "CONTRIBUTOR" */
  type?: RestApiEvaluationGroupContributorValueType
}

export interface RestAPIEvaluationGroupManagerValue {
  /** @default null */
  value?: RestAPICampaignAssigneeKey | null | (RestAPICampaignAssigneeKey & null)
  label: RestAPII18NString
  /** @default "MANAGER" */
  type?: RestApiEvaluationGroupManagerValueType
}

export interface RestAPIEvaluationGroupStatusValue {
  value: RestApiEvaluationGroupStatusValueValue
  label: RestAPII18NString
  /** @default "STATUS" */
  type?: RestApiEvaluationGroupStatusValueType
}

export type RestAPIEvaluationGroup =
  | RestAPIEvaluationGroupCampaignValue
  | RestAPIEvaluationGroupPerimeterValue
  | RestAPIEvaluationGroupPolicyValue
  | RestAPIEvaluationGroupQuestionnaireValue
  | RestAPIEvaluationGroupContributorValue
  | RestAPIEvaluationGroupManagerValue
  | RestAPIEvaluationGroupStatusValue

export interface RestAPIEvaluationCampaign {
  id: number
  name: RestAPII18NString
  /** @default null */
  policy?: RestAPICampaignReference | null | (RestAPICampaignReference & null)
  /** @default null */
  questionnaire?: RestAPICampaignReference | null | (RestAPICampaignReference & null)
}

export interface RestAPIEvaluationPerimeter {
  id: number
  identifier: string
  name: RestAPII18NString
  /** @default null */
  type?: RestApiEvaluationPerimeterType | null
}

export interface RestAPIListedEvaluation {
  campaign: RestAPIEvaluationCampaign
  perimeter: RestAPIEvaluationPerimeter
  status: RestApiListedEvaluationStatus
  progression: number
  contributors: RestAPICampaignAssignee[]
  managers: RestAPICampaignAssignee[]
  /**
   * @format date
   * @default null
   */
  validation_date?: string | null
}

export interface RestAPIEvaluationGroupData {
  group?: RestAPIEvaluationGroup
  items: RestAPIListedEvaluation[]
  total: number
}

export interface RestAPIPaginatedGroupEvaluationsResponse {
  groups: RestAPIEvaluationGroupData[]
  paging: RestAPICampaignPagingGroupData
}

export interface RestAPILabelScoresBody {
  label_ids: number[]
}

export interface RestAPILabelScore {
  label_id: number
  /** @default null */
  current_reduction?: number | null
  /** @default null */
  current_target?: number | null
}

export interface RestAPILabelScoresListResponse {
  data: RestAPILabelScore[]
}

export interface RestMeasureScoresRequest {
  ids: number[]
}

export interface RestMeasureScore {
  id: number
  /** @default null */
  operation_score?: number | null
  /** @default null */
  performance_score?: number | null
  efficiency: number
  is_default: boolean
}

export interface RestMeasureScoresResponse {
  data: RestMeasureScore[]
}

export interface RestAPIMeasureGroupedFilter {
  perimeter_id: number
  /** @default null */
  implemented_by?: RestAPIPredicateFilter[] | null
  /** @default null */
  policy_id?: RestAPIPredicateFilter[] | null
  /** @default null */
  requirement_id?: RestAPIPredicateFilter[] | null
  /** @default null */
  status?: RestAPIPredicateFilter[] | null
  /** @default null */
  search?: RestAPIPredicateFilter[] | null
  /** @default null */
  has_actions?: RestAPIPredicateFilter[] | null
  /** @default null */
  has_risks?: RestAPIPredicateFilter[] | null
  /** @default null */
  score_default?: RestAPIPredicateFilter[] | null
  /** @default null */
  score_with_controls?: RestAPIPredicateFilter[] | null
  /** @default null */
  efficiency?: RestAPIPredicateFilter[] | null
}

export interface RestAPIMeasureGroupBy {
  group: RestApiMeasureGroupByGroup
  limit_per_group: number
}

export interface RestAPIMeasureGroupedRequest {
  measure_filter: RestAPIMeasureGroupedFilter
  /** @default null */
  sort_field?: RestApiMeasureGroupedRequestSortField
  /** @default null */
  sort_order?: RestApiMeasureGroupedRequestSortOrder
  /** @default null */
  group_by?: RestAPIMeasureGroupBy | null | (RestAPIMeasureGroupBy & null)
  /** @default null */
  pagination?: RestApiRequestPaginationPayload | null | (RestApiRequestPaginationPayload & null)
}

export interface RestAPIMeasureGroupStatusValue {
  value: RestApiMeasureGroupStatusValueValue
  label: RestAPII18NString
  /** @default "STATUS" */
  type?: RestApiMeasureGroupStatusValueType
}

export interface RestAPIMeasureGroupRequirementValue {
  value: number
  label: RestAPII18NString
  /** @default false */
  not_applicable?: boolean
  /** @default "REQUIREMENT" */
  type?: RestApiMeasureGroupRequirementValueType
}

export interface RestAPIMeasureGroupImplementedByValue {
  /** @default null */
  value?: number | null
  label: RestAPII18NString
  /** @default "IMPLEMENTED_BY" */
  type?: RestApiMeasureGroupImplementedByValueType
}

export type RestAPIMeasureGroup =
  | RestAPIMeasureGroupStatusValue
  | RestAPIMeasureGroupRequirementValue
  | RestAPIMeasureGroupImplementedByValue

export interface RestAPIMeasureRights {
  change_status: boolean
  edit_built_measure: boolean
  edit: boolean
  delete: boolean
}

export interface RestAPIMeasureCounts {
  /** @default null */
  actions?: number | null
  /** @default null */
  risks?: number | null
  /** @default null */
  requirements?: number | null
}

export interface RestAPIPerimeter1 {
  id: number
  identifier: string
  name: RestAPII18NString
}

export interface RestAPIGroupedMeasure {
  id: string
  identifier: string
  status: RestApiGroupedMeasureStatus
  name: RestAPII18NString
  description: RestAPII18NString
  rights: RestAPIMeasureRights
  counts: RestAPIMeasureCounts
  /** @default null */
  db_id?: number | null
  /** @default null */
  perimeter?: RestAPIPerimeter1 | null | (RestAPIPerimeter1 & null)
  /** @default null */
  efficiency?: number | null
  /** @default false */
  has_inconsistent_efficiency?: boolean
  /** @default null */
  computed_efficiency?: number | null
  /** @default null */
  operation_score?: number | null
  /** @default null */
  performance_score?: number | null
  /** @default false */
  score_is_default?: boolean
  /** @default false */
  not_applicable?: boolean
}

export interface RestAPIMeasureGroupData {
  group?: RestAPIMeasureGroup
  items: RestAPIGroupedMeasure[]
  total: number
}

export interface RestAPIMeasureGroupListMeta {
  status_count: Record<string, number>
  has_inconsistent_efficiency: boolean
}

export interface RestAPIPagingGroupData {
  page_count: number
  count: number
  groups_count: number
}

export interface RestAPIListRights {
  create: boolean
}

export interface RestAPIPaginatedGroupMeasuresResponse {
  groups: RestAPIMeasureGroupData[]
  meta: RestAPIMeasureGroupListMeta
  paging: RestAPIPagingGroupData
  rights: RestAPIListRights
}

export interface RestAPIMetadataDefinitionListQueryParams {
  /** @default null */
  search?: string | null
  /** @default null */
  definition_ids?: number[] | null
  /**
   * @min 1
   * @default 1
   */
  page?: number
  /**
   * @min 1
   * @max 50
   * @default 20
   */
  per_page?: number
}

export interface RestAPIMetadataDefinitionResponse {
  id: number
  customer_id: number
  identifier: string
  name_fr: string
  name_en: string
  description_fr: string
  description_en: string
  value_validation: Record<string, any>
  value_type: RestApiMetadataDefinitionResponseValueType
}

export interface RestAPIMetadataDefinitionListResponse {
  paging: RestAPIPagingData
  data: RestAPIMetadataDefinitionResponse[]
}

export interface RestAPIMetadataChoice {
  i18n: Record<string, string>
  /**
   * @default null
   * @pattern ^#[0-9a-fA-F]{6}$
   */
  color?: string | null
}

export interface RestAPIMetadataDefinitionValueValidationPayload {
  /** @default null */
  pattern?: string | null
  /**
   * @min 0
   * @max 10
   * @default null
   */
  precision?: number | null
  /** @default null */
  true_label?: RestAPIMetadataChoice | null | (RestAPIMetadataChoice & null)
  /** @default null */
  false_label?: RestAPIMetadataChoice | null | (RestAPIMetadataChoice & null)
  /** @default null */
  date_type?: RestApiMetadataDefinitionValueValidationPayloadDateType | null
  /** @default null */
  date_format?: RestApiMetadataDefinitionValueValidationPayloadDateFormat | null
  /** @default null */
  choices?: object | null
  /** @default null */
  multi?: boolean | null
}

export interface RestAPIMetadataDefinitionRequestPayload {
  identifier: string
  name_fr: string
  name_en: string
  description_fr: string
  description_en: string
  value_validation: RestAPIMetadataDefinitionValueValidationPayload
  value_type: RestApiMetadataDefinitionRequestPayloadValueType
}

export interface RestAPIMetadataDefinitionUpdatePayload {
  name_fr: string
  name_en: string
  description_fr: string
  description_en: string
  value_validation: RestAPIMetadataDefinitionValueValidationPayload
  remap?: Record<string, string | null>
  /** @default false */
  discard_invalid_values?: boolean
}

export interface RestAPIMetadataItem {
  item_type: RestApiMetadataItemItemType
  item_id: number
}

export interface RestAPIMetadataValueListQueryParams {
  /** @default null */
  definition_ids?: number[] | null
  /** @default null */
  item_types?: RestApiMetadataValueListQueryParamsItemTypes[] | null
  /** @default null */
  items?: RestAPIMetadataItem[] | null
  /**
   * @min 1
   * @default 1
   */
  page?: number
  /**
   * @min 1
   * @max 50
   * @default 20
   */
  per_page?: number
}

export interface RestAPIMetadataValueResponse {
  id: number
  metadata_definition_id: number
  item_type: RestApiMetadataValueResponseItemType
  item_id: number
  value: any
  formatted_value: any
}

export interface RestAPIMetadataValueListResponse {
  paging: RestAPIPagingData
  data: RestAPIMetadataValueResponse[]
}

export interface RestAPIMetadataItemValuesPatchPayload {
  values: Record<string, any>
}

export interface RestAPIMetadataItemValueError {
  code: RestApiMetadataItemValueErrorCode
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
}

export interface RestAPIMetadataItemValuesErrorDetail {
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
  values: Record<string, RestAPIMetadataItemValueError>
}

export interface RestAPIMetadataItemValuesErrorResponse {
  errors: RestAPIMetadataItemValuesErrorDetail
}

export interface RestAPIMetadataItemValuesResponse {
  data: RestAPIMetadataValueResponse[]
}

export interface RestAPIPerimeterListResponse {
  data: RestAPIPerimeter[]
}

export interface RestAPII18NStringOptionalInput {
  /** @default null */
  en?: string | null
  /** @default null */
  fr?: string | null
}

export interface RestAPIPolicyInput {
  id: number
  /**
   * @min 0
   * @max 100
   * @default 50
   */
  percentage?: number
  /**
   * @min 0
   * @max 100
   * @default 0
   */
  priority?: number
}

export interface RestAPIPerimeterCreateRequest {
  type: RestApiPerimeterCreateRequestType
  name: RestAPII18NStringInput
  /**
   * Ids of grouping perimeters to attach the perimeter to. Omitted or null: attached to the customer root.
   * @minItems 1
   * @default null
   */
  parent_perimeter_ids?: number[] | null
  /** @default null */
  description?: RestAPII18NStringOptionalInput | null | (RestAPII18NStringOptionalInput & null)
  /**
   * @default null
   * @pattern ^[a-zA-Z0-9_.\-]{2,10}$
   */
  identifier?: string | null
  /**
   * @min 0
   * @max 100
   * @default null
   */
  weight?: number | null
  /**
   * @default null
   * @pattern ^#[0-9a-fA-F]{6}$
   */
  color?: string | null
  /** @default null */
  force_main_score_type?: RestApiPerimeterCreateRequestForceMainScoreType | null
  /** @default null */
  labels?: RestAPII18NStringInput[] | null
  /** @default null */
  policies?: RestAPIPolicyInput[] | null
}

export interface RestAPIPerimeterCreatedCampaign {
  id: number
  name: RestAPII18NString
}

export interface RestAPIPerimeterCreatedResponse {
  id: number
  /** @default null */
  identifier?: string | null
  name: RestAPII18NString
  /** @default null */
  type?: string | null
  /** @default null */
  weight?: number | null
  /** @default null */
  color?: string | null
  edit_right: boolean
  delete_right: boolean
  parent_tag_ids: number[]
  mandatory_input: boolean
  campaigns: RestAPIPerimeterCreatedCampaign[]
}

export interface RestAPIMeasureRights1 {
  change_status: boolean
  edit_built_measure: boolean
  edit: boolean
  delete: boolean
}

export interface RestAPICategory {
  id: number
}

export interface RestAPIToImplementMeasure {
  id: string
  status: RestApiToImplementMeasureStatus
  name: RestAPII18NString
  description: RestAPII18NString
  identifier: string
  rights: RestAPIMeasureRights1
  /** @default null */
  category?: RestAPICategory | null | (RestAPICategory & null)
  /** @default null */
  yearly_internal_cost?: number | null
  /** @default null */
  yearly_internal_load_days?: number | null
}

export interface RestAPIBuiltMeasure {
  id: number
}

export interface RestAPIActionPlan {
  id: number
}

export interface RestAPIImplementationAction {
  id: number
  identifier: string
  name: RestAPII18NString
  action_plan: RestAPIActionPlan
  status: RestApiImplementationActionStatus
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
}

export interface RestAPINotImplementedMeasure {
  id: string
  status: RestApiNotImplementedMeasureStatus
  name: RestAPII18NString
  description: RestAPII18NString
  perimeter: RestAPIPerimeter
  built_measure: RestAPIBuiltMeasure
  rights: RestAPIMeasureRights1
  /** @default null */
  implementation_action?: RestAPIImplementationAction | null | (RestAPIImplementationAction & null)
}

export interface RestAPIImplementedMeasure {
  id: string
  db_id: number
  status: RestApiImplementedMeasureStatus
  name: RestAPII18NString
  description: RestAPII18NString
  perimeter: RestAPIPerimeter
  identifier: string
  built_measure: RestAPIBuiltMeasure
  rights: RestAPIMeasureRights1
  /** @default 100 */
  efficiency?: number
  /** @default null */
  category?: RestAPICategory | null | (RestAPICategory & null)
  /** @default null */
  yearly_internal_cost?: number | null
  /** @default null */
  yearly_internal_load_days?: number | null
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  computed_efficiency?: number | null
  /** @default false */
  has_inconsistent_efficiency?: boolean
}

export type RestAPIFullMeasure = RestAPIToImplementMeasure | RestAPINotImplementedMeasure | RestAPIImplementedMeasure

export interface RestAPIMeasureResponse {
  data?: RestAPIFullMeasure
}

export interface RestAPIPerimeterId {
  id: number
}

export interface RestAPIUpdateMeasureBody {
  status: RestApiUpdateMeasureBodyStatus
  name: RestAPII18NStringInput
  description: RestAPII18NStringOptionalInput
  perimeter: RestAPIPerimeterId
  identifier: string
  /** @default null */
  category?: RestAPICategory | null | (RestAPICategory & null)
  /** @default null */
  yearly_internal_cost?: number | null
  /** @default null */
  yearly_internal_load_days?: number | null
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  built_measure?: RestAPIBuiltMeasure | null | (RestAPIBuiltMeasure & null)
}

export interface RestAPIEditMeasureResponse {
  data: RestAPIImplementedMeasure
}

export interface RestAPIChangeMeasureStatusRequest {
  status: RestApiChangeMeasureStatusRequestStatus
}

export type RestAPIMeasureNotToImplement = RestAPINotImplementedMeasure | RestAPIImplementedMeasure

export interface RestAPIChangeStatusMeasureResponse {
  data?: RestAPIMeasureNotToImplement
}

export interface RestAPIResetMeasureResponse {
  data: RestAPIToImplementMeasure
}

export interface RestAPIGetMeasureBeneficiariesResponse {
  data: RestAPIPerimeter[]
}

export interface RestAPIPutMeasureBeneficiariesRequest {
  beneficiaries: number[]
}

export interface RestAPIMeasureImprovementAction {
  id: number
  identifier: string
  name: RestAPII18NString
  impact: number
  status: RestApiMeasureImprovementActionStatus
  action_plan: RestAPIActionPlan
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
}

export interface RestAPIMeasureImprovementActionsListResponse {
  data: RestAPIMeasureImprovementAction[]
}

export interface RestAPIRunbook {
  id: number
}

export interface RestAPIMeasureRecurringControl {
  id: number
  name: RestAPII18NString
  identifier: string
  type: RestApiMeasureRecurringControlType
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
  /** @default null */
  runbook?: RestAPIRunbook | null | (RestAPIRunbook & null)
}

export interface RestAPIMeasureRecurringControlsResponse {
  data: RestAPIMeasureRecurringControl[]
}

export interface RestAPIMeasureCatalogRecurringControl {
  id: number
  name: RestAPII18NString
  identifier: string
  type: RestApiMeasureCatalogRecurringControlType
}

export interface RestAPIMeasureCatalogRecurringControlsResponse {
  data: RestAPIMeasureCatalogRecurringControl[]
}

export interface RestAPIMeasureEfficiencyUpdateRequest {
  measure_ids: string[]
}

export interface RestAPIMeasureRecurringControlRequest {
  id: number
  type: RestApiMeasureRecurringControlRequestType
  /** @default null */
  runbook_id?: number | null
  /** @default null */
  owner?: RestAPIOwner | null | (RestAPIOwner & null)
}

export interface RestAPIMeasureRecurringControlsRequest {
  recurring_controls: RestAPIMeasureRecurringControlRequest[]
}

export interface RestAPIRiskRegister {
  id: number
}

export interface RestAPIMeasureRisk {
  id: number
  identifier: string
  name: RestAPII18NString
  /** @default null */
  risk_register?: RestAPIRiskRegister | null | (RestAPIRiskRegister & null)
}

export interface RestAPIMeasureRisksResponse {
  data: RestAPIMeasureRisk[]
}

export interface RestAPIPolicyRequirement {
  id: number
  name: RestAPII18NString
  identifier: string
  public: boolean
}

export interface RestAPIMeasureRequirement {
  id: number
  identifier: string
  coverage_percentage: number
  name: RestAPII18NString
  policy: RestAPIPolicyRequirement
}

export interface RestAPIMeasureRequirementsResponse {
  data: RestAPIMeasureRequirement[]
}

export interface RestAPIInconsistentEfficiencyMeasure {
  id: string
  identifier: string
  name: RestAPII18NString
  /** @default null */
  current_efficiency?: number | null
  /** @default null */
  computed_efficiency?: number | null
}

export interface RestAPIInconsistentEfficiencyMeasuresListResponse {
  data: RestAPIInconsistentEfficiencyMeasure[]
}

export interface RestAPIPerimeterAction {
  id: number
  status: string
}

export interface RestAPIPerimeterImplementationStatus {
  status: RestApiPerimeterImplementationStatusStatus
  /** @default null */
  perimeter?: RestAPIPerimeter | null | (RestAPIPerimeter & null)
  /** @default null */
  action?: RestAPIPerimeterAction | null | (RestAPIPerimeterAction & null)
}

export interface RestAPIBeneficiaryPerimeter {
  id: number
  identifier: string
  name: RestAPII18NString
  implementation: RestAPIPerimeterImplementationStatus
}

export interface RestAPIBeneficiariesPerimeterListResponse {
  data: RestAPIBeneficiaryPerimeter[]
}

export interface RestAPIPerimeterTreeFilter {
  /** @default null */
  perimeter_id?: number | null
}

export interface RestAPIPerimeterTreeChildItem {
  child_id: number
  /** @default null */
  parent_id?: number | null
  /** @default null */
  name?: string | null
  /** @default null */
  weight?: number | null
  /** @default null */
  order?: number | null
}

export interface RestAPIPerimeterTreeTagItem {
  db_id: number
  id: string
  perimeter_id: number
  identifier: string
  /** @default null */
  name?: string | null
  /** @default null */
  tag?: string | null
  type: string
  children_: RestAPIPerimeterTreeChildItem[]
  delete_right: boolean
  view_right: boolean
  edit_right: boolean
  /** @default true */
  has_parent?: boolean
  /** @default null */
  parentId?: string | null
}

export interface RestAPIPerimeterTreePerimeterItem {
  db_id: number
  id: string
  identifier: string
  /** @default null */
  name?: string | null
  type: string
  /** @default null */
  perimeter_type?: string | null
  tags: RestAPIPerimeterTreeTagItem[]
  delete_right: boolean
  view_right: boolean
  edit_right: boolean
  desassociate_right: boolean
  mandatory_input: boolean
  /** @default null */
  parentId?: string | null
  /** @default null */
  weight?: number | null
  /** @default null */
  color?: string | null
}

export interface RestAPIPerimeterTreeResponse {
  add_right: boolean
  objects: RestAPIPerimeterTreeTagItem[]
  perimeters: RestAPIPerimeterTreePerimeterItem[]
  tree_root_node_id: number
}

export interface RestAPIImportPerimetersResponse {
  message: RestAPII18NString
  report: string
}

export interface RestAPIPerimeterGroupedFilter {
  /** @default null */
  root_perimeter_id?: RestAPIPredicateFilter[] | null
  /** @default null */
  parent_perimeter_ids?: RestAPIPredicateFilter[] | null
  /** @default null */
  types?: RestAPIPredicateFilter[] | null
  /** @default null */
  search?: RestAPIPredicateFilter[] | null
}

export interface RestAPIPerimeterGroupBy {
  group: RestApiPerimeterGroupByGroup
  limit_per_group: number
}

export interface RestAPIPerimeterGroupedRequest {
  perimeter_filter: RestAPIPerimeterGroupedFilter
  /** @default null */
  sort_field?: RestApiPerimeterGroupedRequestSortField
  /** @default null */
  sort_order?: RestApiPerimeterGroupedRequestSortOrder
  /** @default null */
  group_by?: RestAPIPerimeterGroupBy | null | (RestAPIPerimeterGroupBy & null)
  /** @default null */
  pagination?: RestApiRequestPaginationPayload | null | (RestApiRequestPaginationPayload & null)
}

export interface RestAPIPerimeterGroupTypeValue {
  value: RestApiPerimeterGroupTypeValueValue
  label: RestAPII18NString
  /** @default "TYPE" */
  type?: RestApiPerimeterGroupTypeValueType
}

export interface RestAPIPerimeterParent {
  id: number
  name: RestAPII18NString
  is_root: boolean
  /** @default null */
  tree_name?: RestAPII18NString | null | (RestAPII18NString & null)
}

export interface RestAPIListedPerimeterRights {
  view: boolean
  edit: boolean
  delete: boolean
  disassociate: boolean
}

export interface RestAPIListedPerimeter {
  id: number
  identifier: string
  name: RestAPII18NString
  type: RestApiListedPerimeterType
  parents: RestAPIPerimeterParent[]
  rights: RestAPIListedPerimeterRights
  /** @default null */
  tag_id?: number | null
}

export interface RestAPIPerimeterGroupData {
  /** @default null */
  group?: RestAPIPerimeterGroupTypeValue | null | (RestAPIPerimeterGroupTypeValue & null)
  items: RestAPIListedPerimeter[]
  total: number
}

export interface RestAPIPerimeterPagingGroupData {
  page_count: number
  count: number
  groups_count: number
}

export interface RestAPIPaginatedGroupPerimetersResponse {
  groups: RestAPIPerimeterGroupData[]
  paging: RestAPIPerimeterPagingGroupData
}

export interface RestAPIPolicyPerimeter {
  id: number
  identifier: string
  name: RestAPII18NString
  public: boolean
  perimeters: RestAPIPerimeter[]
}

export interface RestAPIPoliciesPerimeterListResponse {
  data: RestAPIPolicyPerimeter[]
}

export interface RestAPIPolicyPerimeterResponse {
  data: RestAPIPolicyPerimeter
}

export interface RestAPIPolicyPriorityLevel {
  id: number
  name: RestAPII18NString
  value: number
  nb_requirements: number
}

export interface RestAPIPolicyPerimeterPriority {
  perimeter_id: number
  identifier: string
  name: RestAPII18NString
  /** @default null */
  priority_level?: RestAPIPolicyPriorityLevel | null | (RestAPIPolicyPriorityLevel & null)
  weight: number
}

export interface RestAPIPolicyPerimeterPriorityResponse {
  data: RestAPIPolicyPerimeterPriority[]
}

export interface RestAPIPerimeterPriority {
  perimeter_id: number
  /** @default null */
  priority?: number | null
  /** @default null */
  weight?: number | null
}

export interface RestAPIAssociatePerimeterPriorityParams {
  perimeters: RestAPIPerimeterPriority[]
}

export interface RestAPIPerimetersForPolicyResponse {
  data: RestAPIPerimeter[]
}

export interface RestAPIPolicyPriorityScale {
  id: number
  identifier: string
  name: RestAPII18NString
  priority_levels: RestAPIPolicyPriorityLevel[]
}

export interface RestAPIPolicyPriorityScaleResult {
  /** @default null */
  priority_scale?: RestAPIPolicyPriorityScale | null | (RestAPIPolicyPriorityScale & null)
  /** @default null */
  perimeter_priority_level?: RestAPIPolicyPriorityLevel | null | (RestAPIPolicyPriorityLevel & null)
}

export interface RestAPIUpdatePerimeterPriority {
  priority: number
}

export interface RestAPIPolicyPerimeterSimpleResponse {
  policy_id: number
  perimeter_id: number
  priority: number
}

export interface RestAPIPolicyCreateActionsRequest {
  perimeter_id: number
  requirement_ids: number[]
  /** @default null */
  action_plan_id?: number | null
  /** @default null */
  action_plan_name?: RestAPII18NStringInput | null | (RestAPII18NStringInput & null)
  /** @default null */
  manager?: RestAPIOwner | null | (RestAPIOwner & null)
}

export interface RestAPIPolicyCreateActionsResponse {
  action_plan_id: number
  action_plan_name: RestAPII18NString
  nb_of_groups_created: number
  nb_of_actions_created: number
}

export interface RestApiQuota {
  /** @default null */
  max?: number | null
  current: number
}

export interface RestAPIGetQuotasResponseData {
  perimeters: RestApiQuota
  policies: RestApiQuota
}

export interface RestAPIGetQuotasResponse {
  data: RestAPIGetQuotasResponseData
}

export interface RestAPIRiskRegistersRights {
  edit: boolean
  delete: boolean
}

export interface RestAPIRiskCounts {
  risks: number
}

export interface RestAPIRiskRegister1 {
  id: number
  identifier: string
  name: RestAPII18NString
  description: RestAPII18NString
  rights: RestAPIRiskRegistersRights
  /** @default null */
  attachment?: RestAPIRegisterAttachment | null | (RestAPIRegisterAttachment & null)
  /** @default null */
  counts?: RestAPIRiskCounts | null | (RestAPIRiskCounts & null)
  visible_by_everyone: boolean
}

export interface RestAPIRiskRegisterListResponse {
  data: RestAPIRiskRegister1[]
  paging: RestAPIPagingData
}

export interface RestAPIRiskRegisterScores {
  risk_register_id: number
  /** @default null */
  current_reduction?: number | null
  /** @default null */
  current_target?: number | null
}

export interface RestAPIRiskRegisterScoresListResponse {
  data: RestAPIRiskRegisterScores[]
  paging: RestAPIPagingData
}

export interface RestAPIRunbookAllowedAttachmentsResponse {
  allowed_perimeter_ids: number[]
  allowed_tag_ids: number[]
}

export interface RestAPITagDeletionResponse {
  data: boolean
  reasons: string
}

export interface RestAPIMoveTagBody {
  parent_id: number
}

export interface RestAPITagMovedResponse {
  success: boolean
  moved: boolean
}

export interface RestAPIDashboard {
  id: number
  name: RestAPII18NString
}

export interface RestAPIDashboards {
  data: RestAPIDashboard[]
}

export interface RestAPIAttachmentItem {
  type: string
  id: number
  name: RestAPII18NString
}

export interface RestAPIGetAttachmentsData {
  attachments: RestAPIAttachmentItem[]
}

export interface RestAPIGetAttachmentsResponse {
  data: RestAPIGetAttachmentsData
}

export interface RestAPIUserAttachment {
  type: string
  id: number
}

export interface RestAPIAssignAttachmentsRequest {
  attachments?: RestAPIUserAttachment[]
}

export interface RestAPIIntercomToken {
  token: string
}

export enum RestApiRegisterAttachmentType {
  Tag = 'Tag',
  Perimeter = 'Perimeter',
  Provider = 'Provider',
  Application = 'Application',
}

export enum RestApiOwnerType {
  User = 'user',
  Group = 'group',
}

export enum RestApiActionCriteriaStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
}

/** @default null */
export enum RestApiActionCriteriaTemplateType {
  MEASURE_IMPLEMENTATION = 'MEASURE_IMPLEMENTATION',
  MEASURE_IMPROVEMENT = 'MEASURE_IMPROVEMENT',
  EXEMPTION = 'EXEMPTION',
  INCIDENT = 'INCIDENT',
  GAP = 'GAP',
}

export enum RestApiActionCreatedStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

/** @default null */
export enum RestApiActionUpdateRequestStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiActionUpdatedActionType {
  IMPLEMENTATION = 'IMPLEMENTATION',
  IMPROVEMENT = 'IMPROVEMENT',
  SIMPLE = 'SIMPLE',
}

export enum RestApiActionUpdatedStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiActionManagerType {
  User = 'user',
  Group = 'group',
}

export enum RestApiActionRequestFilterPayloadStatuses {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiActionRequestFilterPayloadSources {
  GAP = 'GAP',
  PROJECT = 'PROJECT',
  EXEMPTION = 'EXEMPTION',
  EVALUATION = 'EVALUATION',
  RISK = 'RISK',
  CONTROL = 'CONTROL',
  INCIDENT = 'INCIDENT',
}

export enum RestApiActionRequestFilterPayloadTypes {
  IMPROVEMENT = 'IMPROVEMENT',
  IMPLEMENTATION = 'IMPLEMENTATION',
  SIMPLE = 'SIMPLE',
}

/** @default "IDENTIFIER" */
export enum RestApiActionRequestSortPayloadField {
  IDENTIFIER = 'IDENTIFIER',
  NAME = 'NAME',
  PRIORITY = 'PRIORITY',
  PERIMETER = 'PERIMETER',
  GROUP = 'GROUP',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
  TARGET_DATE = 'TARGET_DATE',
  UPDATED_AT = 'UPDATED_AT',
}

/** @default "ASC" */
export enum RestApiActionRequestSortPayloadOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum RestApiActionPerimeterType {
  INTERNAL = 'INTERNAL',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
}

export enum RestApiActionStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiActionAnomalies {
  TO_PLAN = 'TO_PLAN',
  PLANNED_LATE = 'PLANNED_LATE',
  PLANNED_WITHOUT_START_DATE = 'PLANNED_WITHOUT_START_DATE',
  ONGOING_LATE = 'ONGOING_LATE',
  ONGOING_START_IN_FUTURE = 'ONGOING_START_IN_FUTURE',
  ONGOING_COMPLETED = 'ONGOING_COMPLETED',
  OVERLOADED = 'OVERLOADED',
  EXTRA_COST = 'EXTRA_COST',
  IN_REVIEW_LATE = 'IN_REVIEW_LATE',
}

export enum RestApiActionActionType {
  IMPLEMENTATION = 'IMPLEMENTATION',
  IMPROVEMENT = 'IMPROVEMENT',
  SIMPLE = 'SIMPLE',
}

export enum RestApiActionPerimeterFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionGroupFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionLabelFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionPriorityFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionStatusFilterValueValue {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiActionStatusFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionManagerFilterValueType {
  User = 'user',
  Group = 'group',
}

export enum RestApiActionManagerFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionIsAnomalyFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionActionTypeFilterValueValue {
  IMPROVEMENT = 'IMPROVEMENT',
  IMPLEMENTATION = 'IMPLEMENTATION',
  SIMPLE = 'SIMPLE',
}

export enum RestApiActionActionTypeFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

export enum RestApiActionSourceFilterValueValue {
  GAP = 'GAP',
  PROJECT = 'PROJECT',
  EXEMPTION = 'EXEMPTION',
  EVALUATION = 'EVALUATION',
  RISK = 'RISK',
  CONTROL = 'CONTROL',
  INCIDENT = 'INCIDENT',
}

export enum RestApiActionSourceFilterDataType {
  DISCRETE = 'DISCRETE',
  CONTINUOUS = 'CONTINUOUS',
}

/** @default null */
export enum RestApiActorRequestFilterPayloadType {
  User = 'user',
  Group = 'group',
}

export enum RestApiPredicateFilterOperator {
  In = 'in',
  Contains = 'contains',
  Gte = 'gte',
  Lte = 'lte',
}

export enum RestApiCampaignGroupByGroup {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

/** @default null */
export enum RestApiCampaignGroupedRequestSortField {
  NAME = 'NAME',
  END_DATE = 'END_DATE',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
}

/** @default null */
export enum RestApiCampaignGroupedRequestSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum RestApiCampaignGroupStatusValueValue {
  IN_PREPARATION = 'IN_PREPARATION',
  LAUNCHED = 'LAUNCHED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
}

/** @default "STATUS" */
export enum RestApiCampaignGroupStatusValueType {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

/** @default "PERIMETER" */
export enum RestApiCampaignGroupPerimeterValueType {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

/** @default "POLICY" */
export enum RestApiCampaignGroupPolicyValueType {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

/** @default "QUESTIONNAIRE" */
export enum RestApiCampaignGroupQuestionnaireValueType {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

export enum RestApiCampaignAssigneeKeyType {
  USER = 'USER',
  GROUP = 'GROUP',
}

/** @default "MANAGER" */
export enum RestApiCampaignGroupManagerValueType {
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  MANAGER = 'MANAGER',
}

export enum RestApiCampaignAssigneeType {
  USER = 'USER',
  GROUP = 'GROUP',
}

export enum RestApiCampaignPerimeterType {
  INTERNAL = 'INTERNAL',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
  TAG = 'TAG',
  TREE = 'TREE',
}

export enum RestApiListedCampaignStatus {
  IN_PREPARATION = 'IN_PREPARATION',
  LAUNCHED = 'LAUNCHED',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
}

export enum RestApiEvaluationGroupByGroup {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default null */
export enum RestApiEvaluationGroupedRequestSortField {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  STATUS = 'STATUS',
  VALIDATION_DATE = 'VALIDATION_DATE',
}

/** @default null */
export enum RestApiEvaluationGroupedRequestSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** @default "CAMPAIGN" */
export enum RestApiEvaluationGroupCampaignValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default "PERIMETER" */
export enum RestApiEvaluationGroupPerimeterValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default "POLICY" */
export enum RestApiEvaluationGroupPolicyValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default "QUESTIONNAIRE" */
export enum RestApiEvaluationGroupQuestionnaireValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default "CONTRIBUTOR" */
export enum RestApiEvaluationGroupContributorValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

/** @default "MANAGER" */
export enum RestApiEvaluationGroupManagerValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

export enum RestApiEvaluationGroupStatusValueValue {
  IN_PREPARATION = 'IN_PREPARATION',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
}

/** @default "STATUS" */
export enum RestApiEvaluationGroupStatusValueType {
  CAMPAIGN = 'CAMPAIGN',
  PERIMETER = 'PERIMETER',
  POLICY = 'POLICY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  STATUS = 'STATUS',
}

export enum RestApiEvaluationPerimeterType {
  INTERNAL = 'INTERNAL',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
}

export enum RestApiListedEvaluationStatus {
  IN_PREPARATION = 'IN_PREPARATION',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
}

export enum RestApiMeasureGroupByGroup {
  STATUS = 'STATUS',
  REQUIREMENT = 'REQUIREMENT',
  IMPLEMENTED_BY = 'IMPLEMENTED_BY',
}

/** @default null */
export enum RestApiMeasureGroupedRequestSortField {
  NAME = 'NAME',
  IDENTIFIER = 'IDENTIFIER',
  STATUS = 'STATUS',
  PERIMETER_NAME = 'PERIMETER_NAME',
  EFFICIENCY = 'EFFICIENCY',
  RISK_COUNT = 'RISK_COUNT',
  ACTION_COUNT = 'ACTION_COUNT',
}

/** @default null */
export enum RestApiMeasureGroupedRequestSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum RestApiMeasureGroupStatusValueValue {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

/** @default "STATUS" */
export enum RestApiMeasureGroupStatusValueType {
  STATUS = 'STATUS',
  REQUIREMENT = 'REQUIREMENT',
  IMPLEMENTED_BY = 'IMPLEMENTED_BY',
}

/** @default "REQUIREMENT" */
export enum RestApiMeasureGroupRequirementValueType {
  STATUS = 'STATUS',
  REQUIREMENT = 'REQUIREMENT',
  IMPLEMENTED_BY = 'IMPLEMENTED_BY',
}

/** @default "IMPLEMENTED_BY" */
export enum RestApiMeasureGroupImplementedByValueType {
  STATUS = 'STATUS',
  REQUIREMENT = 'REQUIREMENT',
  IMPLEMENTED_BY = 'IMPLEMENTED_BY',
}

export enum RestApiGroupedMeasureStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiMetadataDefinitionResponseValueType {
  STRING = 'STRING',
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATETIME = 'DATETIME',
}

export enum RestApiMetadataDefinitionValueValidationPayloadDateType {
  DATE = 'DATE',
}

export enum RestApiMetadataDefinitionValueValidationPayloadDateFormat {
  Short = 'short',
  Medium = 'medium',
  Long = 'long',
  Full = 'full',
}

export enum RestApiMetadataDefinitionRequestPayloadValueType {
  STRING = 'STRING',
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATETIME = 'DATETIME',
}

export enum RestApiMetadataItemItemType {
  PERIMETER = 'PERIMETER',
}

export enum RestApiMetadataValueListQueryParamsItemTypes {
  PERIMETER = 'PERIMETER',
}

export enum RestApiMetadataValueResponseItemType {
  PERIMETER = 'PERIMETER',
}

export enum RestApiMetadataItemValueErrorCode {
  UNKNOWN_DEFINITION = 'UNKNOWN_DEFINITION',
  INVALID_VALUE = 'INVALID_VALUE',
}

export enum RestApiPerimeterCreateRequestType {
  INTERNAL = 'INTERNAL',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
  GROUPING = 'GROUPING',
}

export enum RestApiPerimeterCreateRequestForceMainScoreType {
  AUTO = 'AUTO',
  COVERAGE = 'COVERAGE',
  DECLARATIVE = 'DECLARATIVE',
  MEASURED = 'MEASURED',
}

export enum RestApiToImplementMeasureStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiImplementationActionStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiNotImplementedMeasureStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiImplementedMeasureStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiUpdateMeasureBodyStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiChangeMeasureStatusRequestStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiMeasureImprovementActionStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  ONGOING = 'ONGOING',
  STANDBY = 'STANDBY',
  TO_REVIEW = 'TO_REVIEW',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum RestApiMeasureRecurringControlType {
  RECURRING_TASK = 'RECURRING_TASK',
  INDICATOR = 'INDICATOR',
}

export enum RestApiMeasureCatalogRecurringControlType {
  RECURRING_TASK = 'RECURRING_TASK',
  INDICATOR = 'INDICATOR',
}

export enum RestApiMeasureRecurringControlRequestType {
  RECURRING_TASK = 'RECURRING_TASK',
  INDICATOR = 'INDICATOR',
}

export enum RestApiPerimeterImplementationStatusStatus {
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

export enum RestApiPerimeterGroupByGroup {
  TYPE = 'TYPE',
}

/** @default null */
export enum RestApiPerimeterGroupedRequestSortField {
  IDENTIFIER = 'IDENTIFIER',
  NAME = 'NAME',
  TYPE = 'TYPE',
}

/** @default null */
export enum RestApiPerimeterGroupedRequestSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum RestApiPerimeterGroupTypeValueValue {
  TAG = 'TAG',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
  INTERNAL = 'INTERNAL',
}

/** @default "TYPE" */
export enum RestApiPerimeterGroupTypeValueType {
  TYPE = 'TYPE',
}

export enum RestApiListedPerimeterType {
  TAG = 'TAG',
  APPLICATION = 'APPLICATION',
  PROVIDER = 'PROVIDER',
  INTERNAL = 'INTERNAL',
}

/** @default null */
export enum RestV2PerimetersInconsistentEfficiencyMeasuresDetailParamsStatus {
  ALL = 'ALL',
  TO_IMPLEMENT = 'TO_IMPLEMENT',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  IMPLEMENTED = 'IMPLEMENTED',
}

/** @default null */
export enum RestV2PerimetersInconsistentEfficiencyMeasuresDetailParamsSortField {
  NAME_EN = 'NAME_EN',
  NAME_FR = 'NAME_FR',
}

/** @default null */
export enum RestV2RiskRegistersListParamsSortField {
  NameEn = 'name_en',
  NameFr = 'name_fr',
  Identifier = 'identifier',
}

/** @default null */
export enum RestV2RiskRegistersScoresListParamsSortField {
  NameEn = 'name_en',
  NameFr = 'name_fr',
  Identifier = 'identifier',
}

/** @default null */
export enum RestV2UsersListParamsRole {
  Pilot = 'pilot',
  Contributor = 'contributor',
  Auditor = 'auditor',
}
